export  default {
    setLogInjections(state, payload) {
        state.logInjections = payload;
    },
};